import React, { useEffect, useState } from "react"
import styled from "@emotion/styled"
import { getAllElementsByClassName } from "../../helpers"
import { Gallery, Item } from "react-photoswipe-gallery"

import "photoswipe/dist/photoswipe.css"
import "photoswipe/dist/default-skin/default-skin.css"

const GalleryWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  margin: 0 -1rem;
  ${props => props.theme.tablet} {
    flex-direction: column;
    margin: 0;
  }
  img {
    display: block;
    width: 100%;
    background: lightgray;
    height: 100%;
    border: thin #c0c0c0 solid;
    min-height: 200px;
    box-sizing: border-box;
    ${props => props.theme.tablet} {
      width: 100%;
      padding: 0;
      margin-bottom: 1rem;
    }
  }
`

const ItemWrapper = styled.div`
  position: relative;
  flex: 1 0 ${props => props.width};
  padding: 1rem;
  ${props => props.theme.tablet} {
    padding: 0.5rem 0;
  }
`

const ContentGallery = ({ content, width }) => {
  const [contentImages, setContentImages] = useState(null)

  useEffect(() => {
    const getallImages = items => {
      const itemsArray = Array.from(items)
      return itemsArray.map(item => {
        return item.getElementsByTagName("IMG")[0]
      })
    }

    const galleryItems = getAllElementsByClassName(
      content,
      "blocks-gallery-item"
    )

    setContentImages(getallImages(galleryItems))
  }, [content])

  return (
    <Gallery>
      <GalleryWrapper width={width}>
        {contentImages &&
          contentImages.map(image => {
            return (
              <ItemWrapper width={width} key={image.src}>
                <Item
                  original={
                    image.dataset.fullUrl ? image.dataset.fullUrl : image.src
                  }
                  thumbnail={image.src}
                  width="1024"
                  height="768"
                  key={image.className}
                >
                  {({ ref, open }) => (
                    <img
                      ref={ref}
                      onClick={open}
                      alt={image.alt}
                      src={image.src}
                    />
                  )}
                </Item>
              </ItemWrapper>
            )
          })}
      </GalleryWrapper>
    </Gallery>
  )
}

export default ContentGallery
